import { SHOP_DETAIL_ACTION, COMMON_CONTENT_ACTION, SHOP_DETAIL_ACTION_LOADER, SHOP_DETAIL_RESET } from "../type"

const initialState = {
  data: null,
  loader: false,
  common_data: null,
  error: null,
};
const detailReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOP_DETAIL_RESET: return { ...state, data: null, loader: true, error: null, };
    case SHOP_DETAIL_ACTION_LOADER:
      return { ...state, loader: action.loader };

    case SHOP_DETAIL_ACTION:
      return {
        ...state,
        data: action.data || null,
        loader: false,
        error: action.data?.error || null,
      };

    case COMMON_CONTENT_ACTION:
      return { ...state, common_data: action.data };

    default:
      return state;
  }
};

export default detailReducer;
